import { render, staticRenderFns } from "./InfoTooltip.vue?vue&type=template&id=08ef2371&scoped=true"
import script from "./InfoTooltip.vue?vue&type=script&lang=js"
export * from "./InfoTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ef2371",
  null
  
)

export default component.exports